import { useState } from "react";
import { formatTimestamp } from "../../../utils/helper";
import ServiceabilityAuditLog, { PaymentModePill, ServiceablePill, summarizeLog, timeAgo } from "./ServiceabilityAuditLog";

const ServiceabilityListItem = (props: any) => {
    const { data } = props

    const [expandedRows, setExpandedRows] = useState<any>({})

    const toggleRow = (id: any) => {
        setExpandedRows((prev: any) => ({ ...prev, [id]: !prev[id] }))
    }

    return (
        <>
            {data.map((item: any) => {
                const logs = item.auditLogs || []
                const latest = [...logs].sort((a: any, b: any) => (b?.createdAt || 0) - (a?.createdAt || 0))[0]
                const isExpanded = !!expandedRows[item.id]

                return (
                    <>
                        <tr key={item.id} className='[&:nth-child(odd)]:bg-[#f7f7f7]'>
                            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[12%]">{item.msn}</td>
                            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[10%]">{item.categoryCode}</td>
                            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[10%]">{item.zipcode}</td>
                            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[12%]">
                                <ServiceablePill value={item.isServiceable} />
                            </td>
                            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[8%]">
                                <PaymentModePill value={item.isCod} />
                            </td>
                            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[14%]">{formatTimestamp(item.createdAt)}</td>
                            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[14%]">{formatTimestamp(item.updatedAt)}</td>
                            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[20%]">
                                {logs.length ? (
                                    <button
                                        onClick={() => toggleRow(item.id)}
                                        className="text-left group"
                                        title="View change history"
                                    >
                                        <span className="flex items-center gap-1.5">
                                            <span className="px-2 py-0.5 rounded-full bg-[#43425D] text-white text-[10px] font-semibold">
                                                {logs.length} {logs.length === 1 ? "change" : "changes"}
                                            </span>
                                            <span className="text-[10px] text-blue-600 group-hover:underline">
                                                {isExpanded ? "Hide" : "View"}
                                            </span>
                                        </span>
                                        <span className="block text-[10px] text-gray-500 mt-0.5 truncate max-w-[200px]" title={`${summarizeLog(latest)} by ${latest?.performedBy || "System"}`}>
                                            {summarizeLog(latest)} · {timeAgo(latest?.createdAt)}
                                        </span>
                                    </button>
                                ) : (
                                    <span className="text-[11px] text-gray-400">No changes</span>
                                )}
                            </td>
                        </tr>
                        {isExpanded && (
                            <tr key={`${item.id}-audit`} className="bg-[#fbfbfb]">
                                <td colSpan={8} className="px-8 py-2 border-b border-gray-200">
                                    <ServiceabilityAuditLog logs={logs} />
                                </td>
                            </tr>
                        )}
                    </>
                )
            })}
        </>
    )
}

export default ServiceabilityListItem;
